import React from 'react';

import { SimpleImage } from '$partials/media';
import ModuleContainer from '$partials/modules/container.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').StatisticsBlock}
 */
const StatisticsBlock = ({
    ctaLabel,
    ctaLink,
    heading,
    media,
    statistics,
    text,
}) => {
    const hasTable = statistics?.rows?.[0]?.columns?.find((column) => column !== null);

    return (
        <ModuleContainer
            ctaLabel={ctaLabel}
            ctaLink={ctaLink}
            heading={heading}
            text={text}>
            {(hasTable) &&
                <div className={`flex flex-col sm:flex-row sm:border-t border-black sm:pt-8 ${media ? '' : 'pb-30'}`}>
                    {statistics.caption &&
                        <div className='w-full sm:w-2/8 border-b border-black sm:border-0'>
                            <h3 className='flex pt-button-baseline items-center pr-8'>
                                {statistics.caption}
                            </h3>
                        </div>
                    }

                    <table className='w-full sm:w-6/8'>
                        <tbody className='w-full divide-y divide-grey align-top'>
                            {statistics?.rows?.map((row, i) => {
                                return (
                                    <tr
                                        key={i}>
                                        {row?.columns?.map((col, j) => {
                                            let width = '';
                                            switch (j) {
                                                case 0:
                                                    width = 'sm:w-0';
                                                    break;
                                                case 1:
                                                    width = '';
                                                    break;
                                                case 2:
                                                    width = 'sm:w-4/6';
                                                    break;
                                            }

                                            return (
                                                <td
                                                    className={`${width} pr-6 py-button-baseline`}
                                                    key={j}>
                                                    {col}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            }

            {media &&
                <div className='pb-30'>
                    <div className='overflow-hidden rounded'>
                        {media?.image &&
                            <SimpleImage
                                {...media.image}
                                className='w-full'
                                style={{ aspectRatio: `${media.image.width}/${media.image.height}` }} />
                        }
                        {media?.video &&
                            <video
                                autoPlay={true}
                                className='w-full pointer-events-none'
                                loop={true}
                                muted={true}
                                playsInline={true}
                                poster={media.video.poster}
                                src={media.video.src}
                                style={{ aspectRatio: `${media.video.width}/${media.video.height}` }} />
                        }
                    </div>
                </div>
            }
        </ModuleContainer>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default StatisticsBlock;
